import * as React from 'react';

export const SectionTitle = () => {
  return <span />;
};
